<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="operationDutyData"
      style="width: 100.1%;"
    >
      <!-- 删除 -->
      <template slot-scope="{ row, index }" slot="operations">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            v-hasPermission="[
              'operationKpiConfigurationManagement:operationDutyManagement:delete'
            ]"
            @click="operationDutyDelmodal = true"
            >{{ $t("common.del") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 删除 -->
    <Modal v-model="operationDutyDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{
            $t("alarms.common.sureDelete") +
              userName +
              $t("ticket.comment.what")
          }}
          ?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeOperationDuty()"
          >{{ $t("common.del") }}
        </Button>
      </div>
    </Modal>
    <!-- 编辑 -->
    <Modal
      v-model="operationDutyEditModal"
      :title="$t('MCM.dutyManagement.editDuty')"
      :loading="loading"
      @on-ok="operationDutySubmit('operationDutyEditForm')"
      @on-cancel="operationDutyReset('operationDutyEditForm')"
      :mask-closable="false"
      :okText="$t('alarms.common.add')"
      :cancelText="$t('alarms.common.cancel')"
    >
      <Form
        ref="operationDutyEditForm"
        :model="operationDutyEditForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <!-- 姓名 -->
        <FormItem :label="$t('MCM.dutyManagement.name')" prop="name">
          <Select v-model="operationDutyEditForm.name" style="width:300px;">
            <Option
              :value="item.id"
              v-for="item in nameList"
              v-bind:key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 值班类型 -->
        <FormItem :label="$t('MCM.dutyManagement.dutyType')" prop="ondutyType">
          <Select
            v-model="operationDutyEditForm.ondutyType"
            style="width:300px;"
          >
            <Option
              :value="item.id"
              v-for="item in ondutyTypeList"
              v-bind:key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 值班时间 -->
        <FormItem :label="$t('MCM.dutyManagement.dutyTime')" prop="ondutyTime">
          <DatePicker
            type="date"
            :placeholder="$t('MCM.dutyManagement.pleaseSelectDutyTime')"
            style="width:300px;"
            @on-change="operationDutyEditForm.ondutyTime = $event"
            :value="operationDutyEditForm.ondutyTime"
          ></DatePicker>
        </FormItem>
        <!-- 排班优先级 -->
        <FormItem
          :label="$t('MCM.dutyManagement.priority')"
          prop="schedulingPriority"
        >
          <Select
            v-model="operationDutyEditForm.schedulingPriority"
            style="width:300px;"
          >
            <Option
              :value="item.id"
              v-for="item in schedulingPriorityList"
              v-bind:key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 备注 -->
        <FormItem :label="$t('MCM.dutyManagement.comment')" prop="remark">
          <Input
            v-model="operationDutyEditForm.remark"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder="Enter something..."
            style="width:300px;"
          ></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";

var tableOperationDutyManagementVue = {};
export default {
  name: "TableOperationDutyManagement",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      operationDutyDelmodal: false,
      operationDutyEditModal: false,
      userName: "",
      name: "",
      ondutyType: "",
      startDate: "",
      modal_loading: false,
      loading: true,
      nameList: [],
      ondutyTypeList: [
        {
          id: 0,
          name: this.$t("MCM.dutyManagement.dayShift")
        },
        {
          id: 1,
          name: this.$t("MCM.dutyManagement.nightShift")
        }
      ],
      operationDutyEditForm: {
        name: "",
        ondutyType: "",
        ondutyTime: "",
        schedulingPriority: "",
        remark: ""
      },
      // 排班优先级
      schedulingPriorityList: [],
      columns: [
        {
          title: this.$t("MCM.dutyManagement.name"),
          key: "userName",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.operationDutyEditModal = true; //编辑弹出层
                    this.operationDutyEditForm.id = params.row.id;
                    // 姓名
                    this.$api.user.getOperationUsers({}).then(res => {
                      this.nameList = res.data;
                    });

                    this.operationDutyEditForm.name = params.row.userId;
                    // 值班类型
                    this.operationDutyEditForm.ondutyType =
                      params.row.shiftType;
                    // 值班时间
                    this.operationDutyEditForm.ondutyTime =
                      params.row.shiftDate;
                    // 排班优先级
                    this.operationDutyEditForm.schedulingPriority =
                      params.row.schedulingPriority;
                    // 备注
                    this.operationDutyEditForm.remark = params.row.remark;
                  }
                }
              },
              params.row.userName
            );
          }
        },
        {
          title: this.$t("MCM.dutyManagement.dutyType"),
          key: "shift"
        },
        {
          title: this.$t("MCM.dutyManagement.dutyTime"),
          key: "shiftDate"
        },
        {
          title: this.$t("MCM.dutyManagement.priority"),
          key: "schedulingPriorityString"
        },
        {
          title: this.$t("MCM.dutyManagement.comment"),
          key: "remark"
        },
        {
          title: this.$t("MCM.dutyManagement.operation"),
          slot: "operations",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.doDelete(params.index);
                      this.operationDutyDelmodal = true;
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array(
                        "operationKpiConfigurationManagement:operationDutyManagement:delete"
                      )
                    }
                  ]
                },
                "删除"
              )
            ]);
          }
        }
      ],
      ruleValidate: {
        name: [
          {
            required: true,
            message: this.$t("MCM.dutyManagement.pleaseSelectName"),
            trigger: "change",
            type: "number"
          }
        ],
        ondutyType: [
          {
            required: true,
            message: this.$t("MCM.dutyManagement.pleaseSelectDutyType"),
            trigger: "change",
            type: "number"
          }
        ],
        schedulingPriority: [
          {
            required: true,
            message: this.$t("MCM.dutyManagement.pleaseSelectPriority"),
            trigger: "change",
            type: "number"
          }
        ],
        ondutyTime: [
          {
            required: true,
            message: this.$t("MCM.dutyManagement.pleaseSelectDutyTime")
          }
        ],
        remark: [
          {
            required: false,
            message: this.$t(
              "MCM.extraContributionManagement.pleaseEnterDescription"
            ),
            trigger: "blur"
          },
          {
            type: "string",
            max: 10000,
            message: this.$t(
              "MCM.extraContributionManagement.EnterMaximumOfCharacters"
            ),
            trigger: "blur"
          }
        ]
      },
      operationDutyData: []
    };
  },
  beforeCreate: function() {
    tableOperationDutyManagementVue = this;
  },
  mounted: function() {
    tableOperationDutyManagementVue.getOperationDutyManagementData();
    this.selectSchedulingPriorityList();
  },
  methods: {
    // 查询排班优先级
    selectSchedulingPriorityList: function() {
      this.$api.kpiShift
        .selectSchedulingPriorityList("userName", getCookie(global.cookieName))
        .then(res => {
          this.schedulingPriorityList = res.data;
        });
    },
    showAll: function() {
      tableOperationDutyManagementVue.getOperationDutyManagementData();
    },
    // 分页显示数据
    getOperationDutyManagementData: function() {
      eventBus.$on("name", function(name) {
        tableOperationDutyManagementVue.name = name;
      });
      eventBus.$on("ondutyType", function(ondutyType) {
        tableOperationDutyManagementVue.ondutyType = ondutyType;
      });
      eventBus.$on("startDate", function(startDate) {
        tableOperationDutyManagementVue.startDate = startDate;
      });
      // 列表分页
      this.$api.kpiShift
        .pageOperationDuty({
          userName: tableOperationDutyManagementVue.name,
          shiftType: tableOperationDutyManagementVue.ondutyType,
          startTime: tableOperationDutyManagementVue.startDate,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.operationDutyData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableOperationDutyManagementVue.getOperationDutyManagementData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableOperationDutyManagementVue.getOperationDutyManagementData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("name");
      eventBus.$off("ondutyType");
      eventBus.$off("startDate");
    },
    /**************************删除****************************/
    // 删除
    doDelete: function(index) {
      this.lineIndex = index;
      this.userName = this.operationDutyData[index].userName;
    },
    removeOperationDuty: function() {
      var lineIndex = this.lineIndex;
      // 删除
      this.$api.kpiShift
        .deleteOperationDuty("id", this.operationDutyData[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            // 21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableOperationDutyManagementVue.getOperationDutyManagementData();
            this.modal_loading = false;
            this.operationDutyDelmodal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    // 确定
    operationDutySubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.kpiShift
            .checkRepetitionShift({
              userId: this.operationDutyEditForm.name,
              shiftType: this.operationDutyEditForm.ondutyType,
              shiftDate: this.operationDutyEditForm.ondutyTime,
              schedulingPriority: this.operationDutyEditForm.schedulingPriority
            })
            .then(res => {
              if (res.status == 200) {
                this.$api.kpiShift
                  .insertOrUpdate({
                    id: this.operationDutyEditForm.id,
                    userId: this.operationDutyEditForm.name,
                    shiftType: this.operationDutyEditForm.ondutyType,
                    shiftDate: this.operationDutyEditForm.ondutyTime,
                    remark: this.operationDutyEditForm.remark,
                    schedulingPriority: this.operationDutyEditForm
                      .schedulingPriority
                  })
                  .then(res => {
                    setTimeout(() => {
                      tableOperationDutyManagementVue.showAll();
                      this.$refs[name].resetFields();
                      this.loading = false;
                      this.$nextTick(() => {
                        this.loading = true;
                      });
                      this.$Message.success("编辑成功");
                      this.operationDutyEditModal = false;
                    }, 1000);
                  });
              }
            })
            .catch(err => {
              if (err.status == 400) {
                this.loading = false;
                setTimeout(() => {
                  this.loading = true;
                }, 0);
                this.$Modal.error({
                  title: "系统提示",
                  content:
                    "姓名、值班类型、值班时间、排班优先级不能重复不能重复!"
                });
              }
            });
        } else {
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error("编辑失败");
        }
      });
    },
    // 取消
    operationDutyReset: function(name) {
      this.$refs[name].resetFields();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/operation_kpi_configuration_management/operation_duty_management/TableOperationDutyManagement.vue